import ApiError422Handler from './ApiError422Handler'

class ApiError401Handler {
  handleError (error) {
    if (error.response.status === 401) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      location.replace('/')
      return ''
    }

    return ApiError422Handler.handleError(error)
  }
}

export default new ApiError401Handler()
